import(/* webpackMode: "eager" */ "/codebuild/output/src3826801360/src/octocare-website/app/blog/[slug]/page.tsx");
